import { ModelRow } from "@mcleod/core";
import { Component, DataSourceMode, TableRow } from "..";

export function getRelevantModelRow(component: Component): ModelRow {
    if (component.hasBoundField() !== true)
        return null;
    if (component.searchOnly === true) {
        const searchRow = component.dataSource?.searchRow;
        if (searchRow != null)
            return searchRow;
    }
    const activeRow = component.dataSource?.activeRow;
    if (activeRow != null)
        return activeRow;
    const tableRow: TableRow = TableRow.getContainingTableRow(component);
    if (tableRow != null)
        return tableRow.data as ModelRow;
    return null;
}

export function getCurrentDataSourceMode(component: Component): DataSourceMode {
    if (component.hasBoundField() !== true)
        return null;

    if (component.searchOnly === true)
        return DataSourceMode.SEARCH;

    // if the component's datasource has an activeRow, or the dataSource._boundComponents includes this component,
    // then it's not inside a table row, and we can use the DataSource's mode.
    if (component.dataSource && (component.dataSource.activeRow || component.dataSource.isBoundComponent?.(component))) {
        return component.dataSource.mode;
    }

    return TableRow.getContainingTableRow(component)?.getEffectiveDataSourceMode();
}

export function isBoundToPrimaryKeyField(component: Component, includeCompositeKeys: boolean = false): boolean {
    if (component.field == null)
        return false;
    const keyFields = getRelevantModelRow(component)?.getMetadata()?.keyFields;
    if (keyFields == null)
        return false;

    if (includeCompositeKeys) {
        return keyFields.includes(component.field);
    } else {
        return keyFields.length === 1 && keyFields[0] === component.field;
    }
}
